//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
import "../no/FeatureProcessBuilderStatus.js";
let d=[[[0,"FeatureGrouping",1,0],[0,"ResetToolCache",1,0],[0,"Type",1,0]],[[["activeTemplate","featureProcesTemplate"],"GetTemplate",{},0,0],[["activeTemplate","featureProcesTemplate"],"SetTemplate",{},2,0],[["ruleLibraries"],"SetRuleLibraries",{},1,0],[["n_libraries","ruleLibraries"],"GetRuleLibraries",{},0,0],[[],"GetGeometryLocation",{R_:{geometry_location:''}},0,0],[["geometry_location"],"SetGeometryLocation",{},1,0],[["features","numOperations","result_status"],"CreateFeatureProcesses",{R_:{operations:"CAM.Operation[]"}},1,0],[["groups","numOperations","result_status"],"CreateFeatureProcessesWithFeatureGroups",{R_:{operations:"CAM.Operation[]"}},1,0],[["groups","numOperations","result_status"],"RecreateFeatureProcesses",{R_:{operations:"CAM.Operation[]"}},1,0]],[]];
SPLM.CAM.FeatureProcessBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.FeatureProcessBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.FeatureProcessBuilder.FeatureProcessType = Object.freeze({
    "RuleBased" : "RuleBased", "TemplateBased" : "TemplateBased", "OperationSetBased" : "OperationSetBased"});

SPLM.CAM.FeatureProcessBuilder.FeatureGroupingType = Object.freeze({
    "AlwaysCreateNew" : "AlwaysCreateNew", "PerFeature" : "PerFeature", "UseExisting" : "UseExisting"});

export default SPLM;